import { getPeriodTypeFromId } from "../period/PeriodType.js";
import Model from "../Model.js";

/**
 * Represent when the VAT should be payed to the government, e.g.,
 * monthly or quarterly.
 *
 * @param {string} [vatPaymentPeriod] - Money will be moved to sum account
 *   the last month of the period (e.g., Month, Bimester, Quarter or Year)
 * @param {integer} [vatPaymentLatency] - Number of days later, move
 *   sum account to tax account
 */
export default class VatPaymentSettingModel extends Model {
	constructor({ vatPaymentPeriod = "", vatPaymentLatency = "" } = {}) {
		super(...arguments);

		this._vatPaymentPeriod = vatPaymentPeriod;
		this._vatPaymentLatency = vatPaymentLatency;
	}

	getVatPaymentPeriod() {
		return this._vatPaymentPeriod;
	}

	setVatPaymentPeriod(value) {
		this._vatPaymentPeriod = value;
	}

	getVatPaymentLatency() {
		return this._vatPaymentLatency;
	}

	setVatPaymentLatency(value) {
		this._vatPaymentLatency = value;
	}

	getVatPaymentPeriodName() {
		const periodType = getPeriodTypeFromId(this._vatPaymentPeriod);
		return periodType ? periodType.getName() : "";
	}

	clone() {
		return this.constructor.materialize(this.serialize(), {});
	}

	_serializedProperties() {
		return {
			...super._serializedProperties(),
			vatPaymentPeriod: this._vatPaymentPeriod,
			vatPaymentLatency: this._vatPaymentLatency,
		};
	}
}
